export const projectBuilder = () => {
    const project = {
        description: null,
        projectTypeId: null,
        laborBudget: null,
        createProjectMaterialDetails: [],
        createProjectMediaFiles: [],
        floorArea: null,
        floorAreaMeasurementUnitId: null,
        calculateMaterialBudget: false,

        setDescription(description) {
            this.description = description
            return this;
        },

        setProjectTypeId(projectTypeId) {
            this.projectTypeId = projectTypeId;
            return this;
        },

        setLaborBudget(laborBudget) {
            this.laborBudget = laborBudget;
            return this;
        },

        setFloorArea(floorArea) {
            this.floorArea = floorArea;
            return this;
        },

        setFloorAreaMeasurementUnitId(floorAreaMeasurementUnitId) {
            this.floorAreaMeasurementUnitId = floorAreaMeasurementUnitId;
            return this;
        },

        setCreateProjectMaterialDetails(createProjectMaterialDetails) {
            this.createProjectMaterialDetails = createProjectMaterialDetails;
            return this;
        },

        setCalculateMaterialBudget(calculateMaterialBudget) {
            this.calculateMaterialBudget = calculateMaterialBudget;
            return this;
        },

        setCreateProjectMediaFiles(createProjectMediaFiles) {
            this.createProjectMediaFiles = createProjectMediaFiles;
            return this;
        },

        addCreateProjectMaterialDetail(createProjectMaterialDetail) {
            this.createProjectMaterialDetails.push(createProjectMaterialDetail);
            return this;
        },

        build() {
            if (this.createProjectMediaFiles.length === 0) {
                delete this.createProjectMediaFiles;
            }
            return this;
        },
    };

    return project;
};